import React from 'react'
import BarChart from '../../../components/Charts/BarChart'
import * as CHART_UTILS from '../../../components/Charts/BarChart.constant'

const HourlyTrend = ({ groupedData }) => {
  const chartLabels = []
  const data = []
  console.log(groupedData)
  if (groupedData && Array.isArray(groupedData)) {
    for (const hourlyData of groupedData) {
      let totalQuantity = 0

      if (!Array.isArray(hourlyData.data)) {
        chartLabels.push(hourlyData.hour)
        data.push(totalQuantity)
        continue
      }

      hourlyData.data.forEach((data) => {
        totalQuantity += data.partCount
      })

      chartLabels.push(hourlyData.hour)
      data.push(totalQuantity)
    }
  }

  const dataGroup = [
    {
      ...CHART_UTILS.BAR,
      barThickness: 15,
      label: 'Quantity',
      data: data,
      backgroundColor: '#7afade',
      borderColor: '#04b890'
    }
  ]

  return (
    <div
      style={{
        padding: '16px',
        height: '100%'
      }}
    >
      <BarChart
        chartTitle="Hourly part produced"
        chartLabels={chartLabels}
        dataGroup={dataGroup}
        xLabel="Hours"
        yLabel="Quantity produced"
        height="35%"
      />
    </div>
  )
}

export default HourlyTrend
